import React, { lazy, Suspense } from 'react';
// import Footer from './Footer';
// import { Navigation } from '../main/navigation/Navigation';
const Footer = lazy(() => import('./Footer'));
const Navigation = lazy(() => import('../main/navigation/Navigation'));
import { Outlet } from 'react-router-dom';
import MobileNavigation from '../main/navigation/MobileNavigation';
import NavSearch from '../listingMap/NavSearch';
import { MobileTopNavigation } from '../main/navigation/MobileTopNavigation';
import { useIsMobile } from '../../hooks/useIsMobile';

const Layout = () => {
  const isBannerVisible = false;
  const isMobile = useIsMobile();

  return (
    <div className="dark:bg-slate-900 flex flex-col min-h-screen h-screen ">
      <header>
        {isMobile ? (
          <>
            <MobileTopNavigation isBannerVisible={isBannerVisible} />
            <MobileNavigation />
          </>
        ) : (
          <Suspense fallback={null}>
            <Navigation Search={NavSearch} />
          </Suspense>
        )}
      </header>
      <main className={`sm:pt-14 mx-auto bg-white sm:bg-auth-bg  flex flex-col flex-grow w-full`}>
        <Outlet />
      </main>
      {!isMobile && (
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      )}
    </div>
  );
};

export default Layout;
